export const getNumberFromObjects = (objects, key, operator) => {
  let res =
    objects.length === 1
      ? getFirstObjVal(objects[0], key)
      : objects.reduce((result, obj) => {
          let r = 0;
          if (result && !isNaN(result[key]) && obj && !isNaN(obj[key])) {
            r = result[key];
            switch (operator) {
              case "-":
                r = r - obj[key];
                break;
              case "+":
                r = r + obj[key];
                break;
            }
          }
          return { [key]: r };
        })[key];
  return res.toLocaleString("fa");
};

const getFirstObjVal = (obj, key) => {
  return obj && obj[key] ? obj[key] : 0;
};

export const extractItemFromLinkState = (history, key) => {
  const linkState = history.location.state;
  if (linkState && linkState[key]) {
    return linkState[key];
  } else {
    return "";
  }
};
